/**
 * useConfig - Hook to access all app configuration and content data
 */

import { useState, useEffect } from 'react';
import { configService } from '../services/ConfigService';

export function useConfig() {
  const [config, setConfig] = useState(null);
  const [lessons, setLessons] = useState(null);
  const [challenges, setChallenges] = useState(null);
  const [achievements, setAchievements] = useState(null);
  const [interviews, setInterviews] = useState(null);
  const [playground, setPlayground] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        // Check if already loaded
        if (!configService.isLoaded) {
          await configService.loadAll();
        }
        
        // Get all data from ConfigService
        setConfig(configService.getConfig());
        setLessons(configService.getLessons());
        setChallenges(configService.getChallenges());
        setAchievements(configService.getAchievements());
        setInterviews(configService.getInterviews());
        setPlayground(configService.getPlayground());
        setLoading(false);
      } catch (err) {
        console.error('Failed to load config:', err);
        setError(err);
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  return {
    // Data
    config,
    lessons,
    challenges,
    achievements,
    interviews,
    playground,
    
    // Loading states
    loading,
    error,
    isLoaded: !loading && !error,
    
    // Helper methods
    getAppInfo: () => config?.app || {},
    getBranding: () => config?.branding || {},
    getMascot: () => config?.mascot || {},
    getFeatures: () => config?.features || {},
    getGamification: () => config?.gamification || {},
    getNavigation: () => config?.navigation || {},
    getOnboarding: () => config?.onboarding || {},
    isFeatureEnabled: (feature) => config?.features?.[feature] === true,
    isPaidVersion: () => config?.monetization?.enabled === false,
    
    // Content accessors
    getLessonById: (id) => lessons?.lessons?.find(l => l.id === id) || null,
    getChallengeById: (id) => challenges?.challenges?.find(c => c.id === id) || null,
    getCategories: () => lessons?.categories || [],
    getLessonsList: () => lessons?.lessons || [],
    getChallengesList: () => challenges?.challenges || [],
    getBadges: () => achievements?.badges || []
  };
}

export default useConfig;